import React, { useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Popper, ClickAwayListener, Paper } from "@mui/material";
import Button from "@mui/material/Button";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Grow from "@mui/material/Grow";

export default function InstrumentsMenuButton() {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [isOpen, setIsOpen] = React.useState(false); // New state to control Grow animation
	const navigate = useNavigate(); // Hook for programmatic navigation
	const buttonRef = useRef(null); // Ref for focusing the button

	const handleClick = (event) => {
		if (isOpen) {
			handleClose();
		} else {
			setAnchorEl(event.currentTarget);
			setIsOpen(true);
		}
	};

	const handleClose = (event) => {
		setIsOpen(false); // Start the closing animation

		// Focus the button when closing due to Tab press
		if (event?.key === "Tab" && buttonRef.current) {
			buttonRef.current.focus();
		}
	};

	const handleExited = () => {
		setAnchorEl(null); // Only clear anchorEl after the closing animation
	};

	const goToFundamentalsSearch = () => {
		handleClose();
		navigate("/fundamentals-search");
	};

	const goToStockAnalyzer = () => {
		handleClose();
		navigate("/stock-analyzer/AAPL/key-indicators");
	};

	// Function to close the menu when scrolling is detected
	const handleScroll = useCallback(() => {
		if (isOpen) {
			setIsOpen(false);
			setAnchorEl(null);
		}
	}, [isOpen]);

	// Attach scroll event listener
	useEffect(() => {
		if (isOpen) {
			window.addEventListener("scroll", handleScroll, { passive: true });
		} else {
			window.removeEventListener("scroll", handleScroll);
		}

		// Cleanup on component unmount or when menu closes
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [isOpen, handleScroll]);

	const open = Boolean(anchorEl);
	const id = open ? "instruments-menu" : undefined;

	return (
		<React.Fragment>
			<Button
				ref={buttonRef} // Attach ref to button
				variant="text"
				color="inherit"
				size="large"
				disableTouchRipple
				aria-controls={id}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				aria-label="select instrument"
				startIcon={<ShowChartIcon />}
				onClick={handleClick}
				sx={{
					textTransform: "none",
					marginRight: "1rem",
					height: 45,
					mt: "auto",
					mb: "auto",
					borderRadius: 2.5,
					// border: "1px solid gray",
					color: isOpen ? "black" : "rgb(100, 100, 100)",
					"&:hover": {
						// bgcolor: "transparent",
						color: "black",
					},
					position: "relative",
					// "& .MuiTypography-root": {
					// 	position: "relative",
					// 	// fontWeight: "bold",
					// 	// color: "#fff",
					// 	"::after": {
					// 		opacity: 1,
					// 		content: '""',
					// 		position: "absolute",
					// 		width: "0%",
					// 		height: "1px",
					// 		bottom: -1, // Position underline just below text
					// 		left: "50%",
					// 		backgroundColor: "#3a2206", // Color of the underline
					// 		transition: "width 0.3s ease, left 0.3s ease",
					// 		transform: "translateX(-50%)",
					// 	},
					// },
					// "&:hover .MuiTypography-root::after": {
					// 	width: "100%",
					// },
				}}
			>
				{/* Instruments */}
				<Typography variant="body1" fontWeight={"bold"}>
					Instruments
				</Typography>
			</Button>
			<Popper
				id={id}
				open={open}
				anchorEl={anchorEl}
				placement="bottom-end"
				// disablePortal // Prevent rendering in a separate DOM node
				sx={{
					zIndex: 1300,
				}}
			>
				{({ TransitionProps }) => (
					<Grow
						{...TransitionProps}
						in={isOpen}
						onExited={handleExited} // Triggered after closing animation completes
						style={{ transformOrigin: "top right" }}
					>
						<Box
							component={Paper}
							elevation={1}
							sx={{
								// bgcolor: "primary.main",
								// bgcolor: "white",
								// color: "#fff",
								color: "#3a2206",
								borderRadius: "12px",
								width: "250px",
								// border: "1px solid #3a2206",
								border: "1px solid rgba(58, 34, 6, 0.1)",
								// bgcolor: "white",
								// opacity: 0.8,
								bgcolor: "rgba(255, 255, 255, 0.85)", // Semi-transparent background
								backdropFilter: "blur(5px)", // Adds the blur effect
								WebkitBackdropFilter: "blur(5px)", // Safari support
								// boxShadow: '0px 4px 12px rgba(0,0,0,0.32)',
								// filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
								mt: 2.2,
								pr: 0.8,
								pl: 0.8,
							}}
						>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList
									autoFocusItem
									onKeyDown={(event) => {
										if (event.key === "Tab") {
											handleClose(event); // Close the menu and refocus on the button if Tab is pressed
										}
									}}
								>
									<MenuItem
										onClick={goToStockAnalyzer}
										sx={{
											borderRadius: 2,
										}}
									>
										Stock Analyzer
									</MenuItem>
									<MenuItem
										onClick={goToFundamentalsSearch}
										sx={{
											borderRadius: 2,
										}}
									>
										Fundamental Search
									</MenuItem>
									<MenuItem
										onClick={handleClose}
										sx={{
											borderRadius: 2,
										}}
									>
										Fundamental Screener
									</MenuItem>
									<MenuItem
										onClick={handleClose}
										sx={{
											borderRadius: 2,
										}}
									>
										Watch List
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Box>
					</Grow>
				)}
			</Popper>
		</React.Fragment>
	);
}
